import { Lottie } from '~/.client'
import { ClientOnly } from 'remix-utils/client-only'
import type { LottieProps } from '~/.client/lottie'

const LottieAnimation = ({
  data,
  autoplay = true,
  loop = false,
  isVisible = true,
}: LottieProps) => (
  <ClientOnly>
    {() => (
      <Lottie
        data={data}
        autoplay={autoplay}
        loop={loop}
        isVisible={isVisible}
      />
    )}
  </ClientOnly>
)

export default LottieAnimation
